export enum Columns {
    SerialNumber = 'serialNumber',
    Model = 'model',
    Company = 'company',
    Site = 'site',
    LastUsed = 'lastUsed',
    LastCalibration = 'lastCalibration',
    State = 'state'
}
